export const reduceRemoveFirstShownError = (state) => {
  const { errorsToShow } = state;
  const [, ...errorsToShowRest] = errorsToShow;

  return {
    ...state,
    errorsToShow: errorsToShowRest,
  };
};
